export const executionHumanState = {
  NotStarted: "NotStarted",
  InProgress: "InProgress",
  Succeed: "Succeed",
  Ignored: "Ignored",
  Skipped: "Skipped",
  Cancelled: "Cancelled",
  Failed: "Failed",
};
